import { Component, OnInit } from '@angular/core';
import { MatomoService } from '../../services/matomo/matomo.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss'
})
export class TermsComponent implements OnInit {
  constructor(private readonly matomo: MatomoService) {}

  ngOnInit(): void {
    this.matomo.trackPageView('/agb', 'AGB');
  }
}
